export default __webpack_public_path__ + "static/media/pic2.23663e73.jpg";